<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width400 full-height" header="Optionen">
        <div class="flex-col gap-2 height100p">
            <div class="flex-item-fixed">
                <p-message class="mb-3" severity="warning" text="Aktuell nur Suchen, kein Ersetzen"></p-message>
                <sm-form  [form]="formSearch">
                </sm-form>
                <p-button icon="fas fa-search" label="Suchen" (onClick)="search()"></p-button>
            </div>
            <p-tree *ngIf="result != null" class="flex-item-fill height100p full-height" [value]="tree" selectionMode="single" [filter]=true [filterBy]="'data.name,data.internalName,data.tableName'" [(selection)]="selectedMatch" (selectionChange)="selectedMatchChanged()">
            </p-tree>
        </div>
    </p-panel>
    <div class="flex-item-fill">
        <app-ace-editor class="height100p width100p" [class.hidden]="selectedMatch == null" #ace [text]="selectedMatch == null ? '' : _Utils.asSingle(selectedMatch).data.wfEventId != null ? result.wfEventDefinitions[_Utils.asSingle(selectedMatch).data.wfEventId]?.code ?? '' : result.clientEventDefinitions[_Utils.asSingle(selectedMatch).data.clientEventId]?.code ?? ''"></app-ace-editor>
    </div>
</div>
